// VOANH AI Logo (hexagonal cyber emblem)
import React from 'react';

export const VoanhLogo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <defs>
      <linearGradient id='vg' x1='0' y1='0' x2='64' y2='64'>
        <stop offset='0%' stopColor='var(--cyan)' />
        <stop offset='100%' stopColor='var(--neon)' />
      </linearGradient>
    </defs>
    {/* Outer hexagon */}
    <path d='M32 4 L56 18 L56 46 L32 60 L8 46 L8 18 Z' stroke='url(#vg)' strokeWidth='2' fill='rgba(0,229,255,0.05)' />
    {/* Inner hexagon */}
    <path d='M32 16 L46 24 L46 40 L32 48 L18 40 L18 24 Z' stroke='var(--cyan)' strokeWidth='1.2' fill='none' opacity='0.6' />
    {/* Core V */}
    <path d='M24 24 L32 40 L40 24' stroke='url(#vg)' strokeWidth='2.5' fill='none' strokeLinecap='round' strokeLinejoin='round' />
    {/* Center node */}
    <circle cx='32' cy='32' r='2.2' fill='var(--cyan)' />
    {/* Corner nodes */}
    <circle cx='32' cy='4' r='1.5' fill='var(--neon)' />
    <circle cx='56' cy='46' r='1.5' fill='var(--neon)' />
    <circle cx='8' cy='46' r='1.5' fill='var(--neon)' />
  </svg>
);
